"use client";

import type { ThemeProviderProps } from "next-themes";



import { useRouter } from "next/navigation";

import React, { createContext, useContext, useState } from "react";

export interface ProvidersProps {
    children: React.ReactNode;
    themeProps?: ThemeProviderProps;
}

declare module "@react-types/shared" {
    interface RouterConfig {
        routerOptions: NonNullable<
            Parameters<ReturnType<typeof useRouter>["push"]>[1]
        >;
    }
}

export function Providers({ children }: ProvidersProps) {

    const [viewMode, setViewMode] = useState(0);
    return (
        <AuthContext.Provider value={{ viewMode, setViewMode }}>
            {children}
        </AuthContext.Provider>


    );
}



const AuthContext = createContext({
    viewMode: 0,
    setViewMode: (mode: number) => {},
});



export const useAuth = () => useContext(AuthContext);
